/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
import { makeCodecFamily, unitCodec } from "../../codec/index.js";
export const noChangeCodecFamily = makeCodecFamily([[1, unitCodec]]);
//# sourceMappingURL=noChangeCodecs.js.map